export default __webpack_public_path__ + "tels-footer-logo-4e15e6720660ba6a6c501df191c49488.svg";